import React, { FunctionComponent } from 'react'

import { Container } from './styles'
import { ITextProps } from './TextComponent.types'

const Text: FunctionComponent<ITextProps> = ({
  id,
  className,
  children,
  color,
  size,
  fontStyle,
  weight,
  style,
}) => {
  return (
    <Container
      id={id}
      className={className}
      color={color}
      size={size}
      fontStyle={fontStyle}
      weight={weight}
      style={style}
    >
      {children}
    </Container>
  )
}

export default Text
